import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { IntlMsg } from '../_core/IntlMsg/intl-msg.component';
import { messages } from './report-card-unavailable.messages';

// The state for a REPORT_CARD_UNAVAILABLE refusal (readReportCardUnavailable); the raw error is logged by its query.
export const ReportCardUnavailable: React.FC = () => (
  <Box p={4} textAlign="center">
    <Typography variant="h5" gutterBottom>
      <IntlMsg {...messages.title} />
    </Typography>
    <Typography variant="body1" color="textSecondary">
      <IntlMsg {...messages.body} />
    </Typography>
  </Box>
);
